import React, { useState, forwardRef } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

const Navbar = forwardRef(function NavBar(
  {
    currentPage,
    scrollHome,
    scrollAbout,
    scrollCertificates,
    scrollContact,
  },
  navRef
) {
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  const navHome = () => {
    setNav(!nav);
    scrollHome();
  };

  const navAbout = () => {
    setNav(!nav);
    scrollAbout();
  };

  const navCertificates = () => {
    setNav(!nav);
    scrollCertificates();
  };

  const navContact = () => {
    setNav(!nav);
    scrollContact();
  };

  return (
    <div className="z-50 fixed top-0 flex justify-between items-center h-20 w-full mx-auto px-6 md:px-12 text-white bg-black/30 backdrop-blur-xl border-b border-white/10 shadow-lg">
      <h1 className="w-full text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#00df9a] to-emerald-400">
        Martin Mircea
      </h1>
      <ul className="hidden md:flex gap-2">
        {currentPage === 1 ? (
          <li className="px-4 py-2 bg-white/10 rounded-full text-[#00df9a] font-bold transition-all duration-300">
            <button onClick={scrollHome}>Home</button>
          </li>
        ) : (
          <li className="px-4 py-2 hover:bg-white/5 rounded-full text-gray-300 hover:text-white font-medium transition-all duration-300">
            <button onClick={scrollHome}>Home</button>
          </li>
        )}
        {currentPage === 2 ? (
          <li className="px-4 py-2 bg-white/10 rounded-full text-[#00df9a] font-bold transition-all duration-300">
            <button onClick={scrollAbout}>About</button>
          </li>
        ) : (
          <li className="px-4 py-2 hover:bg-white/5 rounded-full text-gray-300 hover:text-white font-medium transition-all duration-300">
            <button onClick={scrollAbout}>About</button>
          </li>
        )}
        {currentPage === 3 ? (
          <li className="px-4 py-2 bg-white/10 rounded-full text-[#00df9a] font-bold transition-all duration-300">
            <button onClick={scrollCertificates}>Certificates</button>
          </li>
        ) : (
          <li className="px-4 py-2 hover:bg-white/5 rounded-full text-gray-300 hover:text-white font-medium transition-all duration-300">
            <button onClick={scrollCertificates}>Certificates</button>
          </li>
        )}
        {currentPage === 4 ? (
          <li className="px-4 py-2 bg-white/10 rounded-full text-[#00df9a] font-bold transition-all duration-300">
            <button onClick={scrollContact}>Contact</button>
          </li>
        ) : (
          <li className="px-4 py-2 hover:bg-white/5 rounded-full text-gray-300 hover:text-white font-medium transition-all duration-300">
            <button onClick={scrollContact}>Contact</button>
          </li>
        )}
      </ul>

      <div onClick={handleNav} className="block md:hidden z-50 p-2 bg-white/10 rounded-full cursor-pointer hover:bg-white/20 transition-all">
        {nav ? <AiOutlineClose size={24} className="text-[#00df9a]" /> : <AiOutlineMenu size={24} />}
      </div>

      <div
        className={
          nav
            ? "fixed left-0 top-0 w-full h-screen bg-black/95 backdrop-blur-3xl text-3xl font-bold ease-in-out duration-500 flex flex-col items-center justify-center gap-10 z-40"
            : "fixed left-[-100%] top-0 w-full h-screen ease-in-out duration-500 bg-black/95 backdrop-blur-3xl text-3xl font-bold flex flex-col items-center justify-center gap-10 z-40"
        }
      >
        <button onClick={navHome} className="hover:text-[#00df9a] transition-colors">Home</button>
        <button onClick={navAbout} className="hover:text-[#00df9a] transition-colors">About</button>
        <button onClick={navCertificates} className="hover:text-[#00df9a] transition-colors">Certificates</button>
        <button onClick={navContact} className="hover:text-[#00df9a] transition-colors">Contact</button>
      </div>
    </div>
  );
});

export default Navbar;
